export function getLocaleDotRound() {
	const num = 1000.5;
	try {
		const string = num.toLocaleString(); // 1.000,5
		// mi aspetto una stringa di 7 caratteri: se non la ottengo significa che nel browser
		// il punto delle migliaia non viene usato, allora restituisco quelle di default
		if (string.length === 7) {
			return {
				dot: string[1],
				round: string[5]
			}					
		}
	} catch(e) {
        console.error(e);
    }

	return {
		dot:'.',
		round: ','
	}
}
